var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"hospitals":_vm.hospitals}}),_c('donor-filter',{on:{"hospitals":function($event){_vm.hospitals = $event},"fetch":_vm.fetch},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('List',{attrs:{"isLoading":_vm.isLoading,"list":_vm.list},on:{"fetch":_vm.fetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }